import { render } from "./image-upload.vue?vue&type=template&id=672e3212"
import script from "./image-upload.vue?vue&type=script&lang=js"
export * from "./image-upload.vue?vue&type=script&lang=js"

import "./image-upload.vue?vue&type=style&index=0&id=672e3212&lang=css"
script.render = render

export default script